import React from 'react';
import type { ColumnConfig } from '@zg-rentals/advanced-table';
import { AdvancedTable, AdvancedTableStyles } from '@zg-rentals/advanced-table';
import { multiFamilyColumnConfig, singleFamilyColumnConfig } from './DailyStatsBreakdownColumnConfigs';

export interface DailyStatsBreakdownRow {
  reportDate: Date;
  impressionCount: number;
  viewCount: number;
  clickCount: number;
  daysOnMarketCount: number;
  leadCount: number;
  emailLeadCount: number;
  phoneLeadCount: number;
  isFreeStat: boolean;
  daysSpotlighted: string;
  totalDaysSpotlighted: number;
  listingWebReferrals: number;
  adClicks: number;
}

interface DailyStatsBreakdownTableProps {
  dailyBreakdown: Array<DailyStatsBreakdownRow>;
  isSingleFamily: boolean;
  isLoading: boolean;
  columnConfig?: Array<ColumnConfig<DailyStatsBreakdownRow>>;
}

/**
 * Displays daily statistics for a single listing in a table format.
 */
export const DailyStatsBreakdownTable = ({
  dailyBreakdown,
  isSingleFamily,
  isLoading,
  columnConfig,
}: DailyStatsBreakdownTableProps) => {
  const defaultColumnConfig = isSingleFamily ? singleFamilyColumnConfig : multiFamilyColumnConfig;
  const dailyBreakdownData = isLoading ? [] : dailyBreakdown;

  return (
    <AdvancedTable
      columnConfig={columnConfig ?? defaultColumnConfig}
      data={dailyBreakdownData}
      isLoading={isLoading}
      tableStyle={AdvancedTableStyles.stripes}
    />
  );
};
